const SB_HASH = {
  details: 'details',
  pool: 'pool',
  snapshots: 'snapshots',
};

Object.freeze(SB_HASH);

export { SB_HASH };
